// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  width: 100%;
  height: 4.375rem;
  top: 0;
  left: 0;
  z-index: 100;
}
.header__content {
  padding: 1.5625rem 0.9375rem;
  display: flex;
  gap: 0.9375rem;
  justify-content: space-between;
  align-items: center;
  position: relative;
  color: #fff;
  transition: all 0.5s ease 0s;
}
.header__content::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 5;
  transition: all 0.3s ease 0s;
}
.header__content .link-action {
  background-color: #92DCE5;
}
._header-scroll .header__content {
  padding: 0.9375rem;
}
.header__logo {
  width: 0rem;
  height: 2.1875rem;
  flex: 0 0 0rem;
  position: relative;
  object-fit: cover;
  position: relative;
  z-index: 30;
  outline: none;
  opacity: 0;
  transition: all 0.5s ease 0s;
  visibility: hidden;
}
.header__logo img {
  position: absolute;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.header._header-scroll .header__logo {
  opacity: 1;
  visibility: visible;
  width: 6rem;
  flex: 0 0 6rem;
}
.header._header-scroll .header__content {
  color: #000;
}
.header._header-scroll .header__content::before {
  background-color: #fff;
  border-bottom: 1px solid #D9D9D9;
}
.header._header-scroll .header__content .link-action {
  background-color: transparent;
}
.header._header-scroll .icon-menu span, .header._header-scroll .icon-menu::before, .header._header-scroll .icon-menu::after {
  background-color: #007587;
}
.menu-open .header .header__logo {
  opacity: 1;
  visibility: visible;
}
.menu-open .header .header__content {
  color: #fff;
}
.menu-open .header .header__content::before {
  background-color: #fff;
  border-bottom: 1px solid #D9D9D9;
}
.menu-open .header .header__content .link-action {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/landing/header/header.scss","webpack://./src/assets/scss/variables.scss"],"names":[],"mappings":"AAKA;EACC,eAAA;EACA,WAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AAJD;AAQC;EACC,4BAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EAEA,WAAA;EACA,4BAAA;AAPF;AASE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,4BAAA;AAPH;AAiBE;EACC,yBAAA;AAfH;AAmBE;EACC,kBAAA;AAjBH;AAsBC;EACC,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;AApBF;AAyBE;EACC,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAvBH;AA4BE;EACC,UAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AA1BH;AA6BE;EACC,WAAA;AA3BH;AA6BG;EACC,sBAAA;EACA,gCAAA;AA3BJ;AA8BG;EACC,6BAAA;AA5BJ;AAkCG;EAGC,yBC3Ga;ADyEjB;AAyCE;EACC,UAAA;EACA,mBAAA;AAvCH;AA0CE;EACC,WAAA;AAxCH;AA0CG;EACC,sBAAA;EACA,gCAAA;AAxCJ;AA2CG;EACC,6BAAA;AAzCJ","sourcesContent":["@import '../../../assets/scss/variable-settings.scss';\r\n@import '../../../assets/scss/mixins.scss';\r\n@import '../../../assets/scss/variables.scss';\r\n\r\n//====================================================================================================\r\n.header {\r\n\tposition: fixed;\r\n\twidth: 100%;\r\n\theight: rem(70);\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 100;\r\n\r\n\r\n\t// .header__content\r\n\t&__content {\r\n\t\tpadding: rem(25) rem(15);\r\n\t\tdisplay: flex;\r\n\t\tgap: rem(15);\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tposition: relative;\r\n\t\t// border-bottom: 1px solid #D9D9D9;\r\n\t\tcolor: #fff;\r\n\t\ttransition: all 0.5s ease 0s;\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tleft: 0;\r\n\t\t\ttop: 0;\r\n\t\t\tz-index: 5;\r\n\t\t\ttransition: all 0.3s ease 0s;\r\n\r\n\t\t\t// @media (max-width:$mobile) {\r\n\t\t\t// \t.menu-open & {\r\n\t\t\t// \t\tborder-bottom: 1px solid #D9D9D9;\r\n\t\t\t// \t\t// box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\n\t\t\t// \t}\r\n\t\t\t// }\r\n\t\t}\r\n\r\n\t\t.link-action {\r\n\t\t\tbackground-color: #92DCE5;\r\n\r\n\t\t}\r\n\r\n\t\t._header-scroll & {\r\n\t\t\tpadding: rem(15);\r\n\t\t}\r\n\t}\r\n\r\n\t// .header__logo\r\n\t&__logo {\r\n\t\twidth: rem(0);\r\n\t\theight: rem(35);\r\n\t\tflex: 0 0 rem(0);\r\n\t\tposition: relative;\r\n\t\tobject-fit: cover;\r\n\t\tposition: relative;\r\n\t\tz-index: 30;\r\n\t\toutline: none;\r\n\t\topacity: 0;\r\n\t\ttransition: all 0.5s ease 0s;\r\n\t\tvisibility: hidden;\r\n\t\t// &:focus {\r\n\t\t// \tbox-shadow: 0px 0px 0px 3px rgba(17, 157, 164, 0.25);\r\n\t\t// }\r\n\r\n\t\timg {\r\n\t\t\tposition: absolute;\r\n\t\t\tobject-fit: contain;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t&._header-scroll {\r\n\t\t.header__logo {\r\n\t\t\topacity: 1;\r\n\t\t\tvisibility: visible;\r\n\t\t\twidth: rem(96);\r\n\t\t\tflex: 0 0 rem(96);\r\n\t\t}\r\n\r\n\t\t.header__content {\r\n\t\t\tcolor: #000;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tbackground-color: #fff;\r\n\t\t\t\tborder-bottom: 1px solid #D9D9D9;\r\n\t\t\t}\r\n\r\n\t\t\t.link-action {\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.icon-menu {\r\n\r\n\t\t\tspan,\r\n\t\t\t&::before,\r\n\t\t\t&::after {\r\n\t\t\t\tbackground-color: $mainBrandColor;\r\n\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.menu-open & {\r\n\t\t.header__logo {\r\n\t\t\topacity: 1;\r\n\t\t\tvisibility: visible;\r\n\t\t}\r\n\r\n\t\t.header__content {\r\n\t\t\tcolor: #fff;\r\n\r\n\t\t\t&::before {\r\n\t\t\t\tbackground-color: #fff;\r\n\t\t\t\tborder-bottom: 1px solid #D9D9D9;\r\n\t\t\t}\r\n\r\n\t\t\t.link-action {\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\r\n}","$mainBrandColor: #007587;\r\n$mainBgGrey: #F0F8F2;\r\n$mainHoverButtonColor: #EDF5F6;\r\n$mainDarkGreen: #003300;\r\n$mainLightBlue: #92DCE5;\r\n\r\n$mainCardTextDarkGrey: #787878;\r\n$mainCardDateGrey: #A8A8A8;\r\n$mainCardTagDarkGrey: #6A6A6A;\r\n$mainLightGrey: #f6f6f6;\r\n$mainCardButtonDark: #383D3B;\r\n$mainSubtitleDarkGrey: #A9A9A9;\r\n$mainDarkCyan: #119DA4;\r\n$mainDarkenDarkCyan: #0082ca;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
